import { bool, string, any, object } from 'prop-types';
import {
  StyledCardDescription,
  StyledCardInfoContainer,
  StyledCardTitle,
  StyledPrimarySection,
  StyledUserCard,
  StyledUserIcon,
} from './styles';

export const UserCard = ({
  isPrimary,
  title,
  description,
  children,
  headerCustomColor,
  dataTestId,
}) => (
  <StyledUserCard
    backgroundColor={headerCustomColor?.dark}
    data-test={dataTestId}
  >
    <StyledPrimarySection>
      <StyledUserIcon
        icon={isPrimary ? 'mywallet-group' : 'mywallet-account'}
        size={38}
        fill="white"
      />
      <StyledCardInfoContainer>
        <StyledCardTitle>{title}</StyledCardTitle>
        <StyledCardDescription>{description}</StyledCardDescription>
      </StyledCardInfoContainer>
    </StyledPrimarySection>
    {children}
  </StyledUserCard>
);

UserCard.propTypes = {
  isPrimary: bool,
  title: string.isRequired,
  description: string.isRequired,
  children: any,
  dataTestId: string,
  headerCustomColor: object,
};
